import { PageId } from 'page-constants'
import { TProgressStep } from 'root-types'

export const PROGRESSBAR_STEPS: TProgressStep[][] = [
  [
    { id: PageId.SIGNUP, text: 'postPaymentProgress.buyPlan' },
    { id: PageId.ACCOUNT, text: 'postPaymentProgress.buyPlan' },
  ],
  [{ id: PageId.DOWNLOAD, text: 'postPaymentProgress.createAccount' }],
]

export const UPSELL_PROGRESSBAR_STEPS: TProgressStep[][] = [
  [
    { id: PageId.UPSELL_GUIDE, text: 'postPaymentProgress.buyPlan' },
    { id: PageId.UPSELL_GUIDE_V2, text: 'postPaymentProgress.buyPlan' },
    { id: PageId.UPSELL_PODCAST, text: 'postPaymentProgress.buyPlan' },
    { id: PageId.INAPP_PODCAST, text: 'postPaymentProgress.buyPlan' },
    { id: PageId.UPSELL_AYAH_PA, text: 'postPaymentProgress.buyPlan' },
    { id: PageId.INAPP_VOICEOVER, text: 'postPaymentProgress.buyPlan' },
    { id: PageId.INAPP_VOICEOVER_V3, text: 'postPaymentProgress.buyPlan' },
    { id: PageId.UPSELL_PARENTING, text: 'postPaymentProgress.buyPlan' },
  ],
  [
    { id: PageId.SIGNUP, text: 'postPaymentProgress.premiumBundle' },
    { id: PageId.ACCOUNT, text: 'postPaymentProgress.premiumBundle' },
  ],
  [{ id: PageId.DOWNLOAD, text: 'postPaymentProgress.createAccount' }],
]

export const UPSELL_PROGRESSBAR_STEPS_ACCOUNT_FIRST: TProgressStep[][] = [
  [
    { id: PageId.SIGNUP, text: 'postPaymentProgress.buyPlan' },
    { id: PageId.ACCOUNT, text: 'postPaymentProgress.buyPlan' },
  ],
  [
    { id: PageId.UPSELL_GUIDE, text: 'postPaymentProgress.createAccount' },
    { id: PageId.UPSELL_GUIDE_V2, text: 'postPaymentProgress.createAccount' },
    { id: PageId.UPSELL_PODCAST, text: 'postPaymentProgress.createAccount' },
    { id: PageId.INAPP_PODCAST, text: 'postPaymentProgress.createAccount' },
    { id: PageId.UPSELL_AYAH_PA, text: 'postPaymentProgress.createAccount' },
    { id: PageId.INAPP_VOICEOVER, text: 'postPaymentProgress.createAccount' },
    {
      id: PageId.INAPP_VOICEOVER_V3,
      text: 'postPaymentProgress.createAccount',
    },
    { id: PageId.UPSELL_PARENTING, text: 'postPaymentProgress.createAccount' },
  ],
  [{ id: PageId.DOWNLOAD, text: 'postPaymentProgress.premiumBundle' }],
]

export const WELLNESS_PROGRESSBAR_STEPS: TProgressStep[][] = [
  [
    { id: PageId.SIGNUP, text: 'postPaymentProgress.buyDeskbook' },
    { id: PageId.ACCOUNT, text: 'postPaymentProgress.buyDeskbook' },
  ],
  [
    { id: PageId.UPSELL_GUIDE, text: 'postPaymentProgress.createAccount' },
    { id: PageId.UPSELL_GUIDE_V2, text: 'postPaymentProgress.createAccount' },
    { id: PageId.UPSELL_PODCAST, text: 'postPaymentProgress.createAccount' },
    { id: PageId.INAPP_PODCAST, text: 'postPaymentProgress.createAccount' },
    { id: PageId.UPSELL_AYAH_PA, text: 'postPaymentProgress.createAccount' },
    { id: PageId.INAPP_VOICEOVER, text: 'postPaymentProgress.createAccount' },
    { id: PageId.INAPP_VOICEOVER_2, text: 'postPaymentProgress.createAccount' },
    {
      id: PageId.INAPP_VOICEOVER_V3,
      text: 'postPaymentProgress.createAccount',
    },
  ],
  [{ id: PageId.APP_WELLNESS, text: 'postPaymentProgress.premiumBundle' }],
]
